//Framework imports
import React, { Fragment, useState } from 'react';
import { useAsync } from 'react-async';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { formatPhoneNumber } from '../../../common/utils';
//import cx from 'classnames';

//Models
import Program from '../../../api/models/program';
import ProgramContact from '../../../api/models/programContact';

//Requests
import ProgramContactRequest from '../../../api/requests/programContactRequest';
import ProgramRequest from '../../../api/requests/programRequest';

//Service imports
import { deleteProgram, updateProgram } from '../../../api/services/programService';
import { getProgram } from '../../../api/services/programService';
import { getSchoolsByDistrict } from '../../../api/services/schoolService';
//import { getDisciplines } from '../../../api/services/disciplineService';
import { getStates } from '../../../api/services/stateService';
import { createProgramContact, deleteProgramContact, getProgramContactsByProgramId, updateProgramContact } from '../../../api/services/programContactService';

//Component imports
import Layout from '../../../components/layout';
import SubmitButton from '../../../components/submitButton';
import DatePicker from 'react-datepicker';
import LayoutError from '../../../components/layoutError';
//import Modal from '../../../components/modal';
import EditModal from '../../../components/editModal'
import ReactPhoneInput from 'react-phone-input-2';
import { FieldInput } from '../../../components/fieldInput';
import { ResponseStatus } from '../../../components/notifications';
import { Tab } from '@headlessui/react';
import District from '../../../api/models/district';
import programContact from '../../../api/models/programContact';
import { hasValue } from '../../../common/utils';
import Select from 'react-select';
import { graySelectStyles } from '../../../common/selectStyles';

type Params = {
  districtId: string;
  id: string;
};
const fetchSchools = async ({ districtId }: any) => {
  return await getSchoolsByDistrict(districtId);
};
const fetchProgram = async ({ id }: any) => {
  return await getProgram(id);
};
const fetchProgramContacts = async ({ id }: any) => {
  return await getProgramContactsByProgramId(id);
};

const EditPrograms = () => {
  //Data Hooks
  const { districtId, id } = useParams<Params>();
  const history = useHistory();
  const [programId, setProgramId] = useState<number | undefined>();
  const [district, setDistrict] = useState<number | undefined>();
  const [schools, setSchools] = useState<(number | undefined)[]>([]);
  //const [program, setProgram] = useState<Program>();
  const [programContactsData, setProgramContactsData] = useState<ProgramContact[]>([]);
  const [districtData, setDistrictData] = useState<District>();

  //Modal Booleans
  const [openAddProgramContactModal, setOpenAddProgramContactModal] = useState(false);

  //General Information Hooks
  const [programName, setProgramName] = useState('');
  const [visible, setVisible] = useState(false);
  const [quickbooksName, setQuickbooksName] = useState('');
  //const [targetHours, setTargetHours] = useState<number>(450 / 60);
  const [fixedTargetHours, setFixedTargetHours] = useState(true);

  //ProgramContacts Fields
  const [addProgramContactId, setAddProgramContactId] = useState<number>(0);
  const [addProgramContactName, setAddProgramContactName] = useState('');
  const [addProgramContactLastName, setAddProgramContactLastName] = useState('');
  const [addProgramContactIsInvoice, setAddProgramContactIsInvoice] = useState(false);
  const [addProgramContactTitle, setAddProgramContactTitle] = useState('');
  const [addProgramContactEmail, setAddProgramContactEmail] = useState('');
  const [addProgramContactPhone, setAddProgramContactPhone] = useState('');
  const [addProgramContactAddress1, setAddProgramContactAddress1] = useState('');
  const [addProgramContactAddress2, setAddProgramContactAddress2] = useState('');
  const [addProgramContactCity, setAddProgramContactCity] = useState('');
  const [addProgramContactStateId, setAddProgramContactStateId] = useState('');
  const [addProgramContactZipcode, setAddProgramContactZipcode] = useState('');
  const [addProgramContactNotes, setAddProgramContactNotes] = useState('');

  //Invoice Fields
  const [isInvoiceSummary, setIsInvoiceSummary] = useState(false);
  const [isInvoiceDetail, setIsInvoiceDetail] = useState(false);
  const [isCdcReport, setIsCdcReport] = useState(false);
  const [deliveryMethod, setDeliveryMethod] = useState('');
  const [paymentBy, setPaymentBy] = useState('');
  const [invoiceDueDate, setInvoiceDueDate] = useState(new Date());
  const [groupInvoiceSummaryBy, setGroupInvoiceSummaryBy] = useState('');
  const [groupInvoiceDetailBy, setGroupInvoiceDetailBy] = useState('');
  const [invoicingNotes, setInvoicingNotes] = useState('');

  /**
   * Data Fetching
   */
  const schoolsData = useAsync({ promiseFn: fetchSchools, districtId });
  /*const disciplineData = useAsync({ promiseFn: getDisciplines });*/
  const statesData = useAsync({ promiseFn: getStates });
  const programContactsAsync = useAsync({
    promiseFn: fetchProgramContacts,
    id,
    onResolve: (response: any) => {
      const programContacts: programContact[] = response.data.programContacts;
      setProgramContactsData(programContacts);
    }
  });
  const fetchData = useAsync({
    promiseFn: fetchProgram,
    id,
    onResolve: (r) => {
      const program: Program = r.data.program;
      if (program !== null && program !== undefined) {
        const district: District = program.district;
        //Set the program
        //setProgram(program);

        //Set general program data
        setProgramName(program.name);
        setProgramId(program.programId);
        setVisible(program.isVisible);
        setQuickbooksName(district.quickbooksName ?? '');
        //setTargetHours(district.targetHours ?? 7.5);
        setFixedTargetHours(district.fixedTargetHours ?? false);

        //Set AR/Invoice tab data
        setIsInvoiceSummary(district.isInvoiceSummary);
        setIsInvoiceDetail(district.isInvoiceDetail);
        setIsCdcReport(district.isCdcReport);
        setDeliveryMethod(district.deliveryMethod);
        setPaymentBy(district.paymentBy);
        setInvoiceDueDate(district.invoiceDueDate ?? new Date());
        setGroupInvoiceSummaryBy(district.groupInvoiceSummaryBy);
        setGroupInvoiceDetailBy(district.groupInvoiceDetailBy);
        setInvoicingNotes(district.notes);

        //Set collections
        setDistrict(district.districtId);
        setSchools(program.programSchools.map((ps) => ps.schoolId));
        setDistrictData(district);
      }
    },
  });

  /**
   * Save Program Logic
   */
  const saveProgram = async () => {
    if (!programId) {
      return Promise.reject('Missing programId.');
    }

    const request: ProgramRequest = {
      name: programName,
      isVisible: visible,
      districtId: district,
      schoolIds: schools,
      //disciplineIds: disciplines,
      quickbooksName: quickbooksName,
      //targetHours: targetHours,
      fixedTargetHours: fixedTargetHours,
      isInvoiceSummary: isInvoiceSummary,
      isInvoiceDetail: isInvoiceDetail,
      isCdcReport: isCdcReport,
      deliveryMethod: deliveryMethod,
      paymentBy: paymentBy,
      invoiceDueDate: invoiceDueDate,
      groupInvoiceSummaryBy: groupInvoiceSummaryBy,
      groupInvoiceDetailBy: groupInvoiceDetailBy,
      notes: invoicingNotes
    };

    return await updateProgram(programId, request);
  };
  const save = useAsync({
    deferFn: saveProgram,
    onResolve: () => {
      history.push(`/admin/districts/${districtId}`, {
        message: `"${programName}" saved successfully!`,
      });
    },
  });

  /**
   * Remove Program Logic
   */
  const removeProgram = async () => {
    if (!programId) {
      return Promise.reject('Missing programId.');
    }

    return await deleteProgram(programId);
  };
  const remove = useAsync({
    deferFn: removeProgram,
    onResolve: () => {
      history.push(`/admin/districts/${districtId}`, {
        message: `"${programName}" removed successfully!`,
      });
    },
  });

  /**
   * ProgramContacts Modal and Data
   */
  const addProgramContactSave = async () => {
    if (!districtId) {
      return Promise.reject('Missing districtId.');
    }

    const programcontactRequest: ProgramContactRequest = {
      districtId: Number(districtId),
      //programContactId: Number(programcontact),
      programId: Number(programId),
      firstName: addProgramContactName,
      lastName: addProgramContactLastName,
      isInvoice: addProgramContactIsInvoice,
      title: addProgramContactTitle,
      email: addProgramContactEmail,
      phone: addProgramContactPhone,
      address1: addProgramContactAddress1,
      address2: addProgramContactAddress2,
      city: addProgramContactCity,
      stateId: Number(addProgramContactStateId) ?? 0,
      zipcode: Number(addProgramContactZipcode) ?? 0,
      notes: addProgramContactNotes
    };

    //Reset modal fields
    setAddProgramContactName('');
    setAddProgramContactLastName('');
    setAddProgramContactIsInvoice(false);
    setAddProgramContactTitle('');
    setAddProgramContactEmail('');
    setAddProgramContactPhone('');
    setAddProgramContactAddress1('');
    setAddProgramContactAddress2('');
    setAddProgramContactCity('');
    setAddProgramContactStateId('');
    setAddProgramContactZipcode('');
    setAddProgramContactNotes('');

    //If we have a conatct ID set, then we are updating the programcontact
    if (addProgramContactId) {
      programcontactRequest.programContactId = addProgramContactId;
      setAddProgramContactId(0);
      return await updateProgramContact(programcontactRequest.programContactId, programcontactRequest);
    }

    return await createProgramContact(programcontactRequest);
  }
  const addProgramContact = useAsync({
    deferFn: addProgramContactSave,
    onResolve: (data: any) => {
      const isUpdating: boolean = data.data === '';
      const programContact: ProgramContact = data.data.programContact ?? JSON.parse(data.config.data);
      let programContacts: ProgramContact[] = programContactsData;

      //find the existing contact record by index
      var existingIndex = -1;
      for (var i = 0; i < programContacts.length; i++) {
        if (programContacts[i].programContactId === programContact.programContactId) {
          existingIndex = i;
          break;
        }
      }

      //if we found an existing index then update that record
      if (existingIndex > -1) {
        //update
        programContacts[existingIndex] = programContact;
      } else {
        //add
        programContacts.push(programContact);
      }

      setProgramContactsData([...programContacts]);

      //Hide modal
      setOpenAddProgramContactModal(false);
    },
    onReject: (data) => { console.log(data); return false; }
  });
  const deleteProgramContactSaveRun = async () => {
    if (!districtId) {
      return Promise.reject('Missing districtId.');
    }

    return await deleteProgramContact(addProgramContactId);
  }
  const removeProgramContact = useAsync({
    deferFn: deleteProgramContactSaveRun,
    onResolve: (data: any) => {
      let programContacts: ProgramContact[] = programContactsData.filter((c) => c.programContactId !== addProgramContactId);
      setProgramContactsData(programContacts);
      setOpenAddProgramContactModal(false);
    },
    onReject: (data) => { console.log(data) }
  });

  /**
   * Modal Initialization Logic
   */
  const initEditProgramContactModal = (programContactId: number) => {
    //Find the programcontact with the given ID
    let programContact: any = programContactsData?.find(c => c.programContactId === programContactId);
    setAddProgramContactId(Number(programContact?.programContactId));
    setAddProgramContactIsInvoice(programContact?.isInvoice);
    setAddProgramContactName(programContact?.firstName);
    setAddProgramContactLastName(programContact?.lastName);
    setAddProgramContactTitle(programContact?.title);
    setAddProgramContactEmail(programContact?.email);
    setAddProgramContactPhone(programContact?.phone);
    setAddProgramContactAddress1(programContact?.address1);
    setAddProgramContactAddress2(programContact?.address2);
    setAddProgramContactCity(programContact?.city);
    setAddProgramContactZipcode(programContact?.zipcode.toString());
    setAddProgramContactStateId(programContact?.stateId.toString());
    setAddProgramContactNotes(programContact?.notes);
    setOpenAddProgramContactModal(true);
  };

  /**
   * Component Handling Logic
   */
  const handleSchoolChange = (e: React.FormEvent<HTMLInputElement>) => {
    if (e.currentTarget.checked) {
      setSchools([...schools, parseInt(e.currentTarget.value)]);
    } else {
      setSchools([
        ...schools.filter((t) => t !== parseInt(e.currentTarget.value)),
      ]);
    }
  };

  /**
   * Error Handling
   */
  if (
    fetchData.error ||
    //disciplineData.error ||
    schoolsData.error ||
    save.error ||
    remove.error ||
    statesData.error ||
    addProgramContact.error ||
    removeProgramContact.error ||
    programContactsAsync.error
  ) return <LayoutError />;

  /**
   * Render
   */
  return (
    <>
      <Layout
        isLoading={
          fetchData.isPending ||
          //disciplineData.isPending ||
          schoolsData.isPending ||
          save.isPending ||
          remove.isPending ||
          statesData.isPending ||
          addProgramContact.isPending ||
          removeProgramContact.isPending ||
          programContactsAsync.isPending
        }
      >
        <>
          <ResponseStatus state={save} />
          <ResponseStatus state={remove} />

          {/* Modal for Add Program Contact */}
          <EditModal
            open={openAddProgramContactModal}
            saveText={`${(!addProgramContactId || addProgramContactId === 0 ? 'Add' : 'Update')} Contact`}
            onSave={() => addProgramContact.run()}
            onCancel={() => setOpenAddProgramContactModal(false)}
            id={addProgramContactId}
            allowSave={
              addProgramContactName !== '' &&
              addProgramContactLastName !== '' &&
              addProgramContactTitle !== '' &&
              addProgramContactAddress1 !== '' &&
              addProgramContactCity !== ''
            }
            disableCancel
          >
            <div className='flex space-x-3 mb-3'>
              <div className='w-full'>
                <FieldInput
                  name='programcontact-name'
                  label='First Name'
                  onChange={(e) => setAddProgramContactName(e.target.value)}
                  value={addProgramContactName}
                  minLength={1}
                />
              </div>
            </div>
            <div className='flex space-x-3 mb-3'>
              <div className='w-full'>
                <FieldInput
                  name='programcontact-last-name'
                  label='Last Name'
                  onChange={(e) => setAddProgramContactLastName(e.target.value)}
                  value={addProgramContactLastName}
                  minLength={1}
                />
              </div>
            </div>
            <div className='flex space-x-3 mb-3'>
              <div className='w-full'>
                <input
                  name='add-programcontact-is-invoice'
                  type='checkbox'
                  className='primary-checkbox'
                  checked={addProgramContactIsInvoice}
                  onChange={(e) => setAddProgramContactIsInvoice(e.currentTarget.checked)}
                />
                <label htmlFor='add-programcontact-is-invoice' className='primary px-2'>Is Invoice</label>
              </div>
            </div>
            <div className='flex space-x-3 mb-3'>
              <div className='w-full'>
                <FieldInput
                  name='programcontact-title'
                  label='Title'
                  onChange={(e) => setAddProgramContactTitle(e.target.value)}
                  value={addProgramContactTitle}
                  minLength={1}
                />
              </div>
            </div>
            <div className='flex space-x-3 mb-3'>
              <div className='w-full'>
                <FieldInput
                  name='programcontact-email'
                  label='Email'
                  onChange={(e) => setAddProgramContactEmail(e.target.value)}
                  value={addProgramContactEmail}
                />
              </div>
            </div>
            <div className='flex space-x-3 mb-3'>
              <div className='w-full'>
                <ReactPhoneInput
                  country={'us'}
                  onChange={(phone) => setAddProgramContactPhone(phone)}
                  value={addProgramContactPhone}
                  disableDropdown={true}
                  disableSearchIcon={true}
                  disableCountryCode={true}
                  enableAreaCodes={true}
                  placeholder={'(555) 555 5555'}
                  specialLabel={'Phone'}
                  onlyCountries={["us"]}
                />
              </div>
            </div>
            <div className='flex space-x-3 mb-3'>
              <div className='w-full'>
                <FieldInput
                  name='programcontact-address-1'
                  label='Address 1'
                  onChange={(e) => setAddProgramContactAddress1(e.target.value)}
                  value={addProgramContactAddress1}
                  minLength={1}
                />
              </div>
            </div>
            <div className='flex space-x-3 mb-3'>
              <div className='w-full'>
                <FieldInput
                  name='programcontact-address-2'
                  label='Address 2'
                  onChange={(e) => setAddProgramContactAddress2(e.target.value)}
                  value={addProgramContactAddress2}
                />
              </div>
            </div>
            <div className='flex space-x-3 mb-3'>
              <div className='w-full'>
                <FieldInput
                  name='programcontact-city'
                  label='City'
                  onChange={(e) => setAddProgramContactCity(e.target.value)}
                  value={addProgramContactCity}
                  minLength={1}
                />
              </div>
            </div>
            <div className='flex space-x-3 mb-3'>
              <div className='w-full'>
                <label className='primary'>State<span className='text-red-500 pl-1'>*</span></label>
                <Select
                  name="programcontact-state"
                  onChange={(selected) => setAddProgramContactStateId(String(selected?.value ?? ''))}
                  className='block mt-1'
                  value={statesData.data?.data.states
                    .map(s => ({ value: s.stateId, label: s.name }))
                    .find(o => String(o.value) === addProgramContactStateId) || null}
                  options={statesData.data?.data.states
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map(s => ({ value: s.stateId, label: s.name })) || []}
                  styles={graySelectStyles}
                />
              </div>
            </div>
            <div className='flex space-x-3 mb-3'>
              <div className='w-full'>
                <FieldInput
                  name='programcontact-zipcode'
                  label='Zip Code'
                  onChange={(e) => setAddProgramContactZipcode(e.target.value)}
                  value={addProgramContactZipcode}
                />
              </div>
            </div>
            <div className='flex space-x-3 mb-3'>
              <div className='w-full'>
                <FieldInput
                  name='programcontact-notes'
                  label='Notes'
                  onChange={(e) => setAddProgramContactNotes(e.target.value)}
                  value={addProgramContactNotes}
                />
              </div>
            </div>
          </EditModal>

          {/* General Information */}
          <div className='grid grid-cols-6 gap-6 mb-6'>
            <div className='col-span-6 sm:col-span-6'>
              <FieldInput
                name='program'
                label='Program'
                minLength={1}
                maxLength={25}
                onChange={(e) => setProgramName(e.target.value)}
                value={programName}
              />
              <p className="text-gray-500">Maximum 25 characters allowed.</p>
            </div>
            <div className='col-span-6 sm:col-span-6'>
              <div className='text-sm'>
                <div className='font-bold'>{districtData?.name}</div>
                <div>{hasValue(districtData?.address1) ? districtData?.address1 : ''}</div>
                {hasValue(districtData?.city) && hasValue(districtData?.stateId) && hasValue(districtData?.zipcode) && (
                  <>
                    <div>{districtData?.address2 !== undefined && districtData?.address2 !== '' ? districtData?.address2 : ''}</div>
                    <div>{`${districtData?.city}, ${(statesData.data?.data.states.filter((s) => s.stateId === (districtData?.stateId))[0]?.name ?? '')}. ${districtData?.zipcode}`}</div>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* Tabs */}
          <Tab.Group>
            {/* Tab List */}
            <Tab.List className='tabs'>
              <Tab as={Fragment}>
                {(btn) => (<button className={btn.selected ? 'active' : ''}>General</button>)}
              </Tab>
              {/*<Tab as={Fragment}>{(btn) => (<button className={btn.selected ? 'active' : ''}>Disciplines</button>)}</Tab>*/}
              <Tab as={Fragment}>
                {(btn) => (<button className={btn.selected ? 'active' : ''}>Schools</button>)}
              </Tab>
              {/*<Tab as={Fragment}>
                {(btn) => (<button className={btn.selected ? 'active' : ''}>Therapy team</button>)}
              </Tab>*/}
              <Tab as={Fragment}>
                {(btn) => (<button className={btn.selected ? 'active' : ''}>AR/Invoice</button>)}
              </Tab>
              {/*<Tab as={Fragment}>
                {(btn) => (<button className={btn.selected ? 'active' : ''}>Metrics/Rules</button>)}
              </Tab>*/}
            </Tab.List>
            {/* Tab Content */}
            <Tab.Panels className='tabpanels'>
              {/* General Tab */}
              <Tab.Panel>
                {/* General Tab Fields */}
                <div className="general-tab-form">
                  <div className='col-span-6 sm:col-span-6'>
                    <div className='flex items-start'>
                      <div className='flex items-center h-5'>
                        <input
                          id='is-visible'
                          name='is-visible'
                          type='checkbox'
                          className='primary-checkbox'
                          checked={visible}
                          onChange={(e) => setVisible(e.currentTarget.checked)}
                        />
                      </div>
                      <div className='ml-3 text-sm'>
                        <label htmlFor='is-visible' className='primary'>
                          Is Visible
                        </label>
                        <p className='text-gray-500'>
                          When checked, this program will be available in the timesheet
                          entry flow.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className='col-span-6 sm:col-span-6 mb-3'>
                    <FieldInput
                      name='quickbooks-name'
                      label='QuickBooks Name'
                      onChange={(e) => setQuickbooksName(e.target.value)}
                      value={quickbooksName}
                    />
                  </div>

                  {/*<div className='col-span-6 sm:col-span-6 mb-3'>
                    <div className='text-sm'>
                      <label htmlFor='requires-monthly-case-notes' className='primary'>
                        Target Hours
                      </label>
                    </div>
                    <input
                      type='number'
                      name='target-hours'
                      id="target-hours"
                      onChange={(e) => setTargetHours(Number(e.target.value))}
                      value={targetHours}
                      placeholder={(450 / 60).toString()}
                      className='w-full'
                    />
                  </div>*/}

                  <div className='col-span-6 sm:col-span-6 mb-3'>
                    <label className='primary'>
                      Fixed Target Hours
                    </label>
                    <Select
                      onChange={(selected) => setFixedTargetHours(selected?.value === 'yes')}
                      className='block mt-1'
                      value={fixedTargetHours ? { value: 'yes', label: 'Yes' } : { value: 'no', label: 'No' }}
                      options={[
                        { value: 'yes', label: 'Yes' },
                        { value: 'no', label: 'No' },
                      ]}
                      styles={graySelectStyles}
                      isSearchable={false}
                    />
                  </div>
                </div>

                {/* ProgramContacts */}
                <div className='col-span-6 sm:col-span-6'>
                  <div className=''>
                    <div className='grid grid-cols-4 gap-2 mb-5'>
                      <h2 className='col-span-3'>Program Contacts</h2>
                      <button
                        className='col-span-1'
                        onClick={() => {
                          setAddProgramContactId(0);
                          setAddProgramContactName('');
                          setAddProgramContactLastName('');
                          setAddProgramContactIsInvoice(false);
                          setAddProgramContactTitle('');
                          setAddProgramContactEmail('');
                          setAddProgramContactPhone('');
                          setAddProgramContactAddress1('');
                          setAddProgramContactAddress2('');
                          setAddProgramContactCity('');
                          setAddProgramContactStateId('0');
                          setAddProgramContactZipcode('');
                          setAddProgramContactNotes('');
                          setOpenAddProgramContactModal(true);
                        }}
                      >Add Program Contact</button>
                    </div>
                    <div>
                      <div className=''>
                        {programContactsData !== undefined &&
                          programContactsData.length > 0 && (
                            <div>
                              <table className='min-w-full divide-y divide-gray-200'>
                                <thead>
                                  <tr>
                                    <td>Name</td>
                                    <td>Invoice</td>
                                    <td>Title</td>
                                    <td>Email</td>
                                    <td>Phone</td>
                                    <td>Address</td>
                                    <td>Notes</td>
                                  </tr>
                                </thead>
                                <tbody className='bg-white divide-y divide-gray-200'>
                                  {programContactsData.sort((a, b) => a.firstName.localeCompare(b.firstName))
                                    .map((d) => (
                                      <tr
                                        key={`programcontact_${d.programContactId}`}
                                        className='cursor-pointer hover:bg-gray-100'
                                        onClick={(e) => {
                                          initEditProgramContactModal(Number(d.programContactId));
                                        }}
                                        id={`programcontact_${d.programContactId}`}
                                        data-programcontactid={d.programContactId}
                                      >
                                        <td className='py-4 break-word'>
                                          <div className='text-sm text-gray-900'>
                                            {d.lastName}, {d.firstName}
                                          </div>
                                        </td>
                                        <td className='py-4 break-word'>
                                          <div className='text-sm text-gray-900'>
                                            <input
                                              id='is-invoice'
                                              name='is-invoice'
                                              type='checkbox'
                                              className='primary-checkbox'
                                              checked={d.isInvoice}
                                              onChange={(e) => setVisible(e.currentTarget.checked)}
                                              disabled
                                            />
                                          </div>
                                        </td>
                                        <td className='py-4 break-word'>
                                          <div className='text-sm text-gray-900'>
                                            {d.title}
                                          </div>
                                        </td>
                                        <td className='py-4 break-word'>
                                          <div className='text-sm text-gray-900'>
                                            {d.email}
                                          </div>
                                        </td>
                                        <td className='py-4 break-word'>
                                          <div className='text-sm text-gray-900'>
                                            {formatPhoneNumber(d.phone ?? '')}
                                          </div>
                                        </td>
                                        <td className='py-4 break-word'>
                                          <div className='text-sm text-gray-900'>
                                            {`${d.address1} ${(d.address2 !== '' ? d.address2 + ', ' : '')}${d.city}, ${(statesData.data?.data.states.filter((s) => s.stateId === d.stateId)[0]?.name ?? '')}. ${d.zipcode}`}
                                          </div>
                                        </td>
                                        <td className='py-4 break-word'>
                                          <div className='text-sm text-gray-900'>
                                            {d.notes && d.notes !== '' ? d.notes : 'None'}
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Panel>

              {/* Disciplines */}
              <>
                {/*<Tab.Panel>
                <div className='col-span-6 sm:col-span-6'>
                  <div className='flex mb-3 justify-between'>
                    <div>
                      <label className='primary'>Disciplines</label>
                      <p className='text-sm text-gray-500'>
                        Select all applicable disciplines.
                      </p>
                    </div>
                    <div className='flex items-end'>
                      <button
                        className='callout'
                        onClick={() => {
                          setModalDisciplines(disciplines);
                          setOpenDisciplines(true);
                        }}
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          className='h-5 w-5'
                          viewBox='0 0 20 20'
                          fill='currentColor'
                        >
                          <path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div className='mt-1 rounded-lg bg-white shadow overflow-hidden'>
                    {(SelectedDisciplines.length === 0 ||
                      disciplines.length ===
                      disciplineData.data?.data.disciplines.length) && (
                        <div className='py-3 px-5'>
                          <div className='text-base font-normal'>Global</div>
                          <p className='text-sm text-gray-500'>
                            Program will be applied to all disciplines.
                          </p>
                        </div>
                      )}

                    {SelectedDisciplines.length !== 0 &&
                      disciplines.length !==
                      disciplineData.data?.data.disciplines.length &&
                      SelectedDisciplines.map((d, i) => {
                        return (
                          <div
                            key={d.disciplineId}
                            className={cx(
                              'flex items-start justify-between py-3 px-5',
                              i % 2 === 0 ? null : 'bg-gray-50'
                            )}
                          >
                            <div className='text-sm'>{d.name}</div>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              className='h-6 w-6 text-red-500 cursor-pointer'
                              onClick={() => handleRemoveDiscipline(d.disciplineId)}
                              viewBox='0 0 20 20'
                              fill='currentColor'
                            >
                              <path
                                fillRule='evenodd'
                                d='M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z'
                                clipRule='evenodd'
                              />
                            </svg>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </Tab.Panel>*/}
              </>

              {/* School */}
              <Tab.Panel>
                <div className='col-span-6 sm:col-span-6'>
                  <label className='primary'>Schools</label>

                  {schoolsData.data?.data.schools !== undefined &&
                    schoolsData.data?.data.schools.length > 0 && (
                      <>
                        <p className='text-sm text-gray-500 mb-3'>
                          Select all applicable schools.
                        </p>
                        <div className='mt-1 rounded-lg bg-white shadow px-4 py-3'>
                          {schoolsData.data?.data.schools
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .map((s, i) => {
                              const sid = `school_${i}`;

                              return (
                                <div key={sid} className='flex items-start py-1'>
                                  <div className='flex items-center h-5'>
                                    <input
                                      id={sid}
                                      value={s.schoolId}
                                      checked={schools.includes(s.schoolId)}
                                      onChange={handleSchoolChange}
                                      name='school'
                                      type='checkbox'
                                      className='primary-checkbox'
                                    />
                                  </div>
                                  <div className='ml-3 text-sm'>
                                    <label htmlFor={sid} className='primary'>
                                      {s.name}
                                    </label>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </>
                    )}

                  {(schoolsData.data?.data.schools === undefined ||
                    schoolsData.data?.data.schools.length === 0) && (
                      <p className='text-sm text-gray-500 mb-3'>
                        No applicable schools.
                      </p>
                    )}
                </div>
              </Tab.Panel>

              {/* Therapy Team
              <Tab.Panel>

              </Tab.Panel> */}

              {/* AR/Invoice */}
              <Tab.Panel>
                {/* Program Billing Contacts */}
                <h2>Program Billing Contacts</h2>
                <div className='mt-2'>
                  {programContactsData !== undefined &&
                    programContactsData.length > 0 && (
                      <div>
                        <table className='min-w-full divide-y divide-gray-200'>
                          <thead>
                            <tr>
                              <td>Name</td>
                              <td>Title</td>
                              <td>Email</td>
                              <td>Phone</td>
                              <td>Address</td>
                              <td>Notes</td>
                            </tr>
                          </thead>
                          <tbody className='bg-white divide-y divide-gray-200'>
                            {programContactsData
                              .sort((a, b) => a.firstName.localeCompare(b.firstName))
                              .filter((c) => c.isInvoice)
                              .map((t) => (
                                <tr
                                  key={`billingProgramContact_${t.programContactId}`}
                                >
                                  <td className='py-4 break-word'>
                                    <div className='text-sm text-gray-900'>
                                      {t.lastName}, {t.firstName}
                                    </div>
                                  </td>
                                  <td className='py-4 break-word'>
                                    <div className='text-sm text-gray-900'>
                                      {t.title}
                                    </div>
                                  </td>
                                  <td className='py-4 break-word'>
                                    <div className='text-sm text-gray-900'>
                                      {t.email}
                                    </div>
                                  </td>
                                  <td className='py-4 break-word'>
                                    <div className='text-sm text-gray-900'>
                                      {formatPhoneNumber(t.phone ?? '')}
                                    </div>
                                  </td>
                                  <td className='py-4 break-word'>
                                    <div className='text-sm text-gray-900'>
                                      {`${t.address1}, ${(t.address2 + ', ' ?? '')}${t.city}, ${(statesData.data?.data.states.filter((s) => s.stateId === t.stateId)[0]?.name ?? '')}. ${t.zipcode}`}
                                    </div>
                                  </td>
                                  <td className='py-4 break-word'>
                                    <div className='text-sm text-gray-900'>
                                      {t.notes ?? 'None'}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                </div>

                {/* AR/Invoice Fields */}
                <h2 className='mt-2'>Invoice Documents</h2>
                <div className='flex'>
                  <div className='flex-1'>
                    <input
                      id='invoice-summary'
                      name='invoice-summary'
                      type='checkbox'
                      className='primary-checkbox'
                      checked={isInvoiceSummary}
                      onChange={(e) => setIsInvoiceSummary(e.currentTarget.checked)}
                    />
                    <label htmlFor='invoice-summary' className='primary px-2 py-2'>Invoice Summary</label>
                  </div>
                  <div className='flex-1'>
                    <input
                      id='invoice-detail'
                      name='invoice-detail'
                      type='checkbox'
                      className='primary-checkbox'
                      checked={isInvoiceDetail}
                      onChange={(e) => setIsInvoiceDetail(e.currentTarget.checked)}
                    />
                    <label htmlFor='invoice-detail' className='primary px-2 py-2'>Invoice Detail</label>
                  </div>
                  <div className='flex-1'>
                    <input
                      id='cpc-report'
                      name='cpc-report'
                      type='checkbox'
                      className='primary-checkbox'
                      checked={isCdcReport}
                      onChange={(e) => setIsCdcReport(e.currentTarget.checked)}
                    />
                    <label htmlFor='cpc-report' className='primary px-2 py-2'>CPC Report</label>
                  </div>
                </div>
                <div className='mt-2'>
                  <label className='mb-2'>Delivery Method:</label>
                  <Select
                    className='w-full'
                    onChange={(selected) => setDeliveryMethod(selected?.value ?? '')}
                    value={[{ value: 'Email', label: 'Email' }, { value: 'Fax', label: 'Fax' }, { value: 'Mail', label: 'Mail' }].find(o => o.value === deliveryMethod) || { value: 'Email', label: 'Email' }}
                    options={[
                      { value: 'Email', label: 'Email' },
                      { value: 'Fax', label: 'Fax' },
                      { value: 'Mail', label: 'Mail' },
                    ]}
                    styles={graySelectStyles}
                    isSearchable={false}
                  />
                </div>
                <div className='mt-2'>
                  <label className='mb-2'>Payment By:</label>
                  <Select
                    className='w-full'
                    onChange={(selected) => setPaymentBy(selected?.value ?? '')}
                    value={[{ value: 'ACH', label: 'ACH' }, { value: 'Check', label: 'Check' }].find(o => o.value === paymentBy) || { value: 'ACH', label: 'ACH' }}
                    options={[
                      { value: 'ACH', label: 'ACH' },
                      { value: 'Check', label: 'Check' },
                    ]}
                    styles={graySelectStyles}
                    isSearchable={false}
                  />
                </div>
                <div className='mt-2'>
                  <div><label className='mb-2'>Invoice Due Date:</label></div>
                  <DatePicker
                    className='block primary mt-1'
                    selected={moment(invoiceDueDate).toDate()}
                    minDate={moment(invoiceDueDate).toDate()}
                    name='invoiceDueDate'
                    onChange={(date: Date) => { setInvoiceDueDate(date!) }}
                    dateFormat="MM-dd-yyyy"
                  />
                </div>
                <h2 className="mt-4">Invoice Report Grouping</h2>
                <div>
                  <label className='mb-2'>Group Invoice Summary By:</label>
                  <Select
                    className='w-full'
                    onChange={(selected) => setGroupInvoiceSummaryBy(selected?.value ?? '')}
                    value={[{ value: 'Discipline', label: 'Discipline' }, { value: 'Grade', label: 'Grade' }, { value: 'School', label: 'School' }].find(o => o.value === groupInvoiceSummaryBy) || null}
                    options={[
                      { value: 'Discipline', label: 'Discipline' },
                      { value: 'Grade', label: 'Grade' },
                      { value: 'School', label: 'School' },
                    ]}
                    styles={graySelectStyles}
                    isSearchable={false}
                  />
                </div>
                <div className='mt-2'>
                  <label className='mb-2'>Group Invoice Detail By:</label>
                  <Select
                    className='w-full'
                    onChange={(selected) => setGroupInvoiceDetailBy(selected?.value ?? '')}
                    value={[{ value: 'Discipline', label: 'Discipline' }, { value: 'Grade', label: 'Grade' }, { value: 'School', label: 'School' }].find(o => o.value === groupInvoiceDetailBy) || null}
                    options={[
                      { value: 'Discipline', label: 'Discipline' },
                      { value: 'Grade', label: 'Grade' },
                      { value: 'School', label: 'School' },
                    ]}
                    styles={graySelectStyles}
                    isSearchable={false}
                  />
                </div>
                <div className='mt-2'>
                  <label className='mb-2'>Additional Invoice Information:</label>
                  <textarea
                    value={invoicingNotes}
                    onChange={(e) => { setInvoicingNotes(e.target.value) }}
                  ></textarea>
                </div>
              </Tab.Panel>

              {/* Metrics/Rules
              <Tab.Panel>

              </Tab.Panel> */}
            </Tab.Panels>
          </Tab.Group>

          {/* Buttons */}
          <div className='flow-root mt-6'>
            <div className='float-left text-left'>
              <SubmitButton
                text='Remove'
                className='secondary'
                disabled={programName.length === 0}
                spinning={remove.isPending}
                onClick={() => remove.run()}
              />
            </div>
            <div className='float-right text-right'>
              <SubmitButton
                text='Save Changes'
                spinning={save.isPending}
                disabled={programName.length === 0}
                onClick={() => save.run()}
              />
            </div>
          </div>
        </>
      </Layout>
    </>
  );
};

export default EditPrograms;
